import { BarChart01Icon } from '@/components/icons/BarChart01Icon';
import { FileSearch02Icon } from '@/components/icons/FileSearch02Icon';
import { Stars01Icon } from '@/components/icons/Stars01Icon';

import {
  OnboardingValueProp,
  OnboardingValuePropCards,
} from '../../../components/OnboardingValuePropCards';

const VALUE_PROPS: OnboardingValueProp[] = [
  {
    Icon: FileSearch02Icon,
    title: 'Summarize documents',
    description: 'Upload and analyze client documents for key information',
  },
  {
    Icon: Stars01Icon,
    title: 'Visualize the estate',
    description:
      'Generate interactive entity diagrams and waterfalls automatically',
  },
  {
    Icon: BarChart01Icon,
    title: 'Model tax outcomes',
    description: 'Calculate estate tax exposure and distribution scenarios',
  },
];

/**
 * The three "what uploading documents enables" cards shown on the document-upload
 * step's landing state (hidden once a document has been uploaded).
 */
export function DocumentValuePropCards() {
  return <OnboardingValuePropCards valueProps={VALUE_PROPS} />;
}
